export default "__VITE_ASSET__B0X1O_wC__";